


import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Card = styled.div`
    /* Base width logic */
    width: ${props => props.large ? '55vw' : '45vw'}; 
    min-width: 340px;
    padding: 35px 25px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    align-items: center;
    background-color: #FFC734;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0px 15px 35px rgba(0,0,0,0.3);
    }

    @media (max-width: 1024px) { 
        width: ${props => props.large ? '60vw' : '48vw'}; 
    }
    @media (max-width: 768px) {
        width: 90vw;
        padding: 20px 15px;
    }
`;

const TopDiv = styled.div`
    width: 96%;
    /* Increase height slightly for the long name to breathe */
    min-height: ${props => props.large ? '300px' : '180px'}; 
    color: #ffffff;
    background-color: #2C2E35;
    border-radius: 15px;
    display: flex;
    align-items: center;
    position: relative;
    overflow: visible; 
`;

const NameDiv = styled.div`
    /* Push width to 75% to give the long name maximum space before it hits the image */
    width: 75%; 
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 0 20px 30px;
    z-index: 2;
`;

const CompanyName = styled.h3`
    margin: 0;
    font-size: ${props => props.large ? '1.4rem' : '1.1rem'};
    font-weight: 500;
    color: #FFC734;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const ModelName = styled.h2`
    margin: 5px 0 0 0;
    /* REDUCED SIZE: Dropped to 2.1rem for large cards so long names fit in 2-3 lines */
    font-size: ${props => props.large ? '2.1rem' : '1.8rem'}; 
    font-weight: 800;
    line-height: 1.2; 
    color: #ffffff;
    
    /* PREVENT WORD SPLITTING: Move whole word to next line */
    word-break: keep-all;
    overflow-wrap: break-word;
    white-space: normal;

    @media (max-width: 576px) { 
        font-size: 1.5rem; 
    }
`;

const Img = styled.img`
    position: absolute;
    /* Pushed further right to stay out of the text's way */
    right: -30px;
    top: 50%;
    transform: translateY(-50%);
    
    width: ${props => props.large ? '50%' : '45%'}; 
    height: ${props => props.large ? '150%' : '140%'}; 
    object-fit: contain;
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    z-index: 10;
    filter: drop-shadow(0 10px 15px rgba(0,0,0,0.3));

    ${Card}:hover & {
        transform: translateY(-55%) rotate(-5deg) scale(1.05);
    }

    @media (max-width: 768px) {
        right: -10px;
    }
`;

const LongBtn = styled.button`
    width: 96%;
    height: 70px; 
    background-color: #ffffff;
    color: #2C2E35;
    border-radius: 12px;
    border: none;
    font-size: 1.6rem;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: #2C2E35;
        color: #ffffff;
    }
`;

const CardProduct = ({ company, name, image, large }) => {
  const navigate = useNavigate();

  let modelType = (company === "IMPACT" && name.includes("Rock Drill")) 
    ? "irds" 
    : (company === "IMPACT" ? "smart" : "itl");

  return (
    <Card large={large} onClick={() => navigate(`/product?type=${modelType}`)}>
      <TopDiv large={large}>
        <NameDiv>
          <CompanyName large={large}>{company}</CompanyName>
          <ModelName large={large}>{name}</ModelName>
        </NameDiv>
        <Img large={large} src={image} alt={name} />
      </TopDiv>
      <LongBtn>
        More Info
      </LongBtn>
    </Card>
  );
};

export default CardProduct;